import React, { Component } from "react";
import AccountingConfForm from "../AccountingConfForm/AccountingConfForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AccountingPage
Description : Componente que contienen el formulario de la pantalla Accounting 
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina – Se llama al componente AccountingForm
================================================================================ */
class AccountingConfPage extends Component{
    render(){
        return(
            <div>                    
                <AccountingConfForm/>
            </div>
        )   
    }
}

export default AccountingConfPage;